import { useDispatch, useSelector } from "react-redux";
import { setTokenInStore } from './tokenTPSlice'
// import { setTenantStore, setTenantNull } from "./tenantSlice";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { setAlertMsgStore } from "./alertMsgSlisce";
import { useGetPersonWhoamiDataMutation, usePostLoginMutation, usePostUserTokenMutation } from "./CallTPApi";
import { setOrderInStore } from "./orderTPSlice";
import { token } from "../interface/Token";
import { useSearchParams } from "react-router-dom";
import { setWhoamitStore } from "./whoamiTPSlice";
import { setTokenAuthenticationInStore } from "./tokenAuthenticationTPSlice";
import { Tenant } from "../interface/Tenant";


export const useTokenTP = () => {
    const [isAuthentication, setIsAuthentication] = useState<boolean>(false)
    const dispatch = useDispatch()
    const token = useSelector((state: any) => state.tokenTP?.value) as token;
    const [postUserToken] = usePostUserTokenMutation()
    const [postLogin] = usePostLoginMutation()
    const [searchParams] = useSearchParams()
    const [getPersonWhoamiData] = useGetPersonWhoamiDataMutation()

    useEffect(() => {
        if (token) {
            const strToken = token as string;
            const decode = jwtDecode(strToken) as any;
            const expToken = decode.exp
            if (expToken) {
                getPersonWhoamiData().then((res: any) => {
                    if (res.data) {
                        dispatch(setWhoamitStore(res.data))
                    }
                })
                const now = Math.floor(Date.now() / 1000);
                if (now < expToken) {
                    // Проверка истечения срока действия токена и запрос нового токена за 5 минут до истечения
                    const timeToRefresh = (expToken - now - 5 * 60) * 1000; // Время до обновления в миллисекундах
                    if (timeToRefresh > 0) {
                        const refreshTimeout = setTimeout(() => {
                            // Здесь вы можете сделать запрос нового токена
                            postUserToken(null).then((res: any) => {
                                if (!res.error) {
                                    setTokenTP(res.data.token)
                                } else {
                                    dispatch(setAlertMsgStore({ variant: 'warning', title: "Ошибка авторизации, попробуйте еще раз" } as any))
                                    // window.alert("Ошибка авторизации, попробуйте еще раз")
                                    // setIsAuthentication(false)
                                    logOutTP()
                                }
                            })
                        }, timeToRefresh);
                        return () => clearTimeout(refreshTimeout); // Очистка таймера при размонтировании компонента
                    }
                }
            }

        }
    }, [token])

    const setTokenTP = (token: string) => {
        if (token === "" || token === undefined) {
            return;
        }
        if (checkTokenExp(token)) {
            setTokenInLocalStorage(token)
            const tokenData = {
                value: token,
            }
            dispatch(setTokenInStore(tokenData))
        }
    }

    const setTokenAuthenticationTP = (token: string) => {
        if (token === "") {
            return;
        }
        if (checkTokenExp(token)) {
            setTokenAuthInLocalStorage(token)
            const tokenData = {
                value: token,
            }
            dispatch(setTokenAuthenticationInStore(tokenData))
        }
    }

    const setDistributorTP = async (getToken = false as boolean) => {
        // const distributorId = searchParams.get("distributorId")
        const distributorId = "585498ce-52d1-46bb-b3e7-6f91dbc92cd7"
        if (!distributorId) {
            return;
        }
        postLogin({ distributorId: distributorId } as any).then((res: any) => {
            if (res.data) {
                console.log(res.data)
                const tenantData = {
                    id: res.data.tenantId,
                } as Tenant;
                localStorage.setItem("tenantIdTP", res.data.tenantId)
                localStorage.setItem("tenantDataTP", JSON.stringify(tenantData))

                if (getToken) {
                    setTokenTP(res.data.token)
                    setTokenAuthenticationTP(res.data.token)
                }
            }
            if (res.error) {
                // dispatch(setAlertMsgStore({
                //     title: "Нет доступа по ссылке",
                //     variant: "danger"
                // } as any))
            }
        })
    }


    const checkTokenExp = (token: string) => {
        if (token === "") {
            localStorage.removeItem('tokenTP')
            localStorage.removeItem('tenantIdTP')
            return false;
        }
        const decode = jwtDecode(token) as any;
        const expToken = decode.exp
        const distributorId = decode.DistributorId
        if (expToken) {
            const now = Math.floor(Date.now() / 1000);
            if (now < new Date(expToken).getTime()) {
                return true;
            }
            else {
                localStorage.removeItem('tokenTP')
                localStorage.removeItem('tokenAuthenticationTP')
                localStorage.removeItem('tenantIdTP')
                localStorage.removeItem('orderTP')
                localStorage.removeItem('sessionIdTP')
                dispatch(setOrderInStore(null as any))
                return false
            }
        }
        else {
            return false;
        }
    }

    const setTokenInLocalStorage = (data: string) => {
        localStorage.setItem('tokenTP', data)
    }
    const setTokenAuthInLocalStorage = (data: string) => {
        localStorage.setItem('tokenAuthenticationTP', data)
    }

    const updateTokenTP = async () => {
        setIsAuthentication(true)
        const tokenAuthentication = localStorage.getItem('tokenAuthenticationTP')
        console.log(tokenAuthentication)
        if (tokenAuthentication != null && checkTokenExp(tokenAuthentication)) {
            const tenantData = localStorage.getItem('tenantDataTP')
            setTokenTP(tokenAuthentication)
            setTokenAuthenticationTP(tokenAuthentication)
            setDistributorTP()
            if (tenantData !== null) {
                const tenant: any = JSON.parse(tenantData);
                if (tenant) {
                    await postUserToken(null).then((res: any) => {
                        if (!res.error) {
                            setTokenTP(res.data.token)
                        } else {
                            dispatch(setAlertMsgStore({ variant: 'warning', title: "Ошибка авторизации, попробуйте еще раз" } as any))
                            // window.alert("Ошибка авторизации, попробуйте еще раз")
                            // setIsAuthentication(false)
                            logOutTP()
                        }
                    })
                }
            }
        }
        else {
            await setDistributorTP(true)
        }
        setIsAuthentication(false)
    }

    const logOutTP = (reload: boolean = true) => {
        // Очищаем локальное хранилище
        const storageKeys = [
            'tenantDataTP',
            'tokenAuthenticationTP',
            'tokenTP',
            'orderTP',
            'sessionIdTP'
        ];
        storageKeys.forEach(key => localStorage.removeItem(key));

        // Сбрасываем состояние Redux
        dispatch(setOrderInStore(null as any));
        dispatch(setTokenInStore(null));
        dispatch(setTokenAuthenticationInStore(null));
        // Перезагружаем страницу при необходимости
        if (reload) {
            window.location.reload();
        }
    };



    return {
        token,
        setTokenAuthenticationTP,
        setTokenTP,
        logOutTP,
        updateTokenTP,
        isAuthentication,
        setIsAuthentication
    }
}




